import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../../components/Header";

// css
import styles from "./mainLayout.module.scss";

import Sidebar from "../../components/Header/sidebar/Sidebar";

const MainLayout = () => {
  const [sidebar, setSidebar] = useState();
  return (
    <>
      <div className="d-flex align-items-start">
        <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
        <main className={`${styles.MainBody} ms-auto MainBody position-relative`}>
          <Header sidebar={sidebar} setSidebar={setSidebar} />
          <Outlet />
        </main>
      </div>
    </>
  );
};
export default MainLayout;
